var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sysBaseForm"},[_c('base-form',{ref:"baseData",attrs:{"options":_vm.baseDataOptions,"rules":_vm.rules,"disabled":_vm.$route.query.type == 'query',"label-width":"105px"},model:{value:(_vm.baseData),callback:function ($$v) {_vm.baseData=$$v},expression:"baseData"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }